




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import dataProxy from '@/services/data-proxy.service'
    import {StatusVozila} from "@/services/BackendProxies";

@Component({})
export default class StatusiVozilaEditor extends Vue {
    statusiVozila = [];
    @Prop() value !: string;

    model = '';

    async created() {
        const statusi = this.statusiVozila = await dataProxy.vratiStatuseVozila();
        statusi.unshift(StatusVozila.fromJS({id: '', naziv: '...'}));
        this.statusiVozila = statusi.map(st => ({id: st.id, text: st.naziv}));
        this.model = this.value;
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Emit() input(val) {

    }

}
